// ABOUTME: Modal shown when pending approval users attempt to login
// ABOUTME: Displays waiting message and admin approval status

import React from 'react';
import './PendingApprovalModal.css';

const PendingApprovalModal = ({ isOpen, onClose, userEmail }) => {
  if (!isOpen) return null;

  return (
    <div className="approval-modal-overlay" onClick={onClose}>
      <div className="approval-modal" onClick={(e) => e.stopPropagation()}>
        <div className="approval-icon">⏳</div>

        <h2>Conta Aguardando Aprovação</h2>

        <p className="approval-main-text">
          Sua conta foi criada com sucesso, mas ainda precisa ser aprovada pela nossa equipe.
        </p>

        <div className="approval-info-box">
          <p>
            <strong>E-mail:</strong> {userEmail}
          </p>
          <p>
            Nossa equipe está revisando seu cadastro. Você receberá um e-mail quando sua conta for aprovada.
          </p>
          <p>
            <strong>Tempo estimado:</strong> Até 24 horas
          </p>
        </div>

        <div className="approval-notice">
          <p>
            <strong>⚠️ Importante:</strong> Aprovamos contas manualmente para garantir a segurança e qualidade do serviço.
          </p>
        </div>

        <button onClick={onClose} className="btn-primary">
          Entendi
        </button>

        <p className="approval-help-text">
          Dúvidas? Entre em contato: help@buenaar.app
        </p>
      </div>
    </div>
  );
};

export default PendingApprovalModal;
